/**
 * @license
 * Visual Blocks Editor
 *
 * Copyright 2016 Massachusetts Institute of Technology
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Control blocks for Scratch (Horizontal)
 * @author ascii@media.mit.edu <Andrew Sliwinski>
 * @edited by barnettm@ethz.ch <Michelle Barnett>
 */
'use strict';

goog.provide('Blockly.Blocks.xlogo');

goog.require('Blockly.Blocks');

goog.require('Blockly.Colours');

Blockly.Blocks['event_greenflag'] = {
  /**
   * Block for when flag clicked.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "event_greenflag",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/event_whenflagclicked.svg",
          "width": 40,
          "height": 40,
          "alt": "When green flag clicked",
          "flip_rtl": true
        }
      ],
      "inputsInline": true,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['history'] = {
  /**
   * Block for when flag clicked.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "history",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/history.png",
          "width": 40,
          "height": 40,
          "alt": "When green flag clicked",
          "flip_rtl": true
        }
      ],
      "inputsInline": true,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": "#FCF1D6",
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['move_forward'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_forward",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_fd_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['move_back'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_back",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_bk_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['move_forward_100'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_forward_100",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_fd_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['move_back_100'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_back_100",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_bk_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

/**
*
* move Step size instead of pixels
*
**/

Blockly.Blocks['move_forward_step'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_forward_step",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_fd_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['move_back_step'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "move_back_step",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_bk_small_arrow.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};



Blockly.Blocks['turn_left'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "turn_left",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_left_general.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['turn_right'] = {
  /**
   * Block to go forward n steps (external number).
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "turn_right",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_right_general.png",
          "width": 40,
          "height": 40,
          "alt": "*"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};




Blockly.Blocks['turn_right_90'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "turn_right_90",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_right.png",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['turn_left_90'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "turn_left_90",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/turtle_left.png",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['wait_100'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "wait_100",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/wait.svg",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['wait'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "wait",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/wait.svg",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};


Blockly.Blocks['control_repeat'] = {
  /**
   * Block for repeat n times (external number).
   * https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#so57n9
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "control_repeat",
      "message0": "%1 %2 %3",
      "args0": [
        {
          "type": "input_statement",
          "name": "SUBSTACK"
        },
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/control_repeat.svg",
          "width": 40,
          "height": 40,
          "alt": "*",
          "flip_rtl": true
        },
        {
          "type": "input_value",
          "name": "TIMES",
          "check": "Number"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['clear_screen'] = {
  /**
   * Block to wait (pause) stack.
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "clear_screen",
      "message0": "%1",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/remove.svg",
          "width": 40,
          "height": 40,
          "alt": "Wait"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};


Blockly.Blocks['set_color'] = {
  /**
   * Block to set pen color
   * @this Blockly.Block
   */
  init: function () {
    this.jsonInit({
      "id": "set_color",
      "message0": "%1 %2",
      "args0": [
        {
          "type": "field_image",
          "src": Blockly.mainWorkspace.options.pathToMedia + "xlogo/pen-blue.svg",
          "width": 40,
          "height": 40,
          "alt": "Broadcast"
        },
        {
          "type": "input_value",
          "name": "CHOICE"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "category": Blockly.Categories.event,
      "colour": Blockly.Colours.event.primary,
      "colourSecondary": Blockly.Colours.event.secondary,
      "colourTertiary": Blockly.Colours.event.tertiary
    });
  }
};

Blockly.Blocks['dropdown_color'] = {
  /**
   * Block for color dropdown (used for shadow).
   * @this Blockly.Block
   */
  init: function () {
    this.appendDummyInput()
      .appendField(new Blockly.FieldIconMenu(
        [
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-black.png',
            value: 'black', width: 48, height: 48, alt: 'Black'
          },
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-blue.svg',
            value: 'blue', width: 48, height: 48, alt: 'Blue'
          },
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-green.png',
            value: 'green', width: 48, height: 48, alt: 'Green'
          },
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-yellow.png',
            value: 'yellow', width: 48, height: 48, alt: 'Yellow'
          },
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-red.png',
            value: 'red', width: 48, height: 48, alt: 'Red'
          },
          {
            src: Blockly.mainWorkspace.options.pathToMedia + 'xlogo/pen-white.png',
            value: 'white', width: 48, height: 48, alt: 'White'
          }
        ]), 'CHOICE');
    this.setOutput(true);
    this.setColour(Blockly.Colours.event.primary,
      Blockly.Colours.event.secondary,
      Blockly.Colours.event.tertiary
    );
  }
};



// WEBPACK FOOTER //
// src/app/lib/xlogo.js